import React from 'react';

import type { RouteMatch } from '@confluence/route';
import { getUniquePageLoadId } from '@confluence/unique-page-load-id';

import { navdexEnd } from '../naxdev';
import { LazyRouteToRightEditor } from '../lazyComponents';

export const EditPageRoute = ({ params: { contentId, spaceKey } }: RouteMatch) => (
	<LazyRouteToRightEditor contentType="pages" contentId={contentId} spaceKey={spaceKey} />
);

EditPageRoute.NAVIGATION_PARAMS = ({ params: { contentId, spaceKey } }: RouteMatch) => ({
	Screen: {
		showPremiumOnboarding: false,
		screenEvent: {
			name: 'editPageScreen',
			id: contentId,
			attributes: {
				...navdexEnd.attributes,
				pageLoadInfo: getUniquePageLoadId(),
			},
		},
		pageState: { contentId, spaceKey },
	},
	MainLayout: false,
});
